import { render } from "./Home.vue?vue&type=template&id=248796e1&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=248796e1&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/03-cococredito-com-prod-k8s-cn/12-ciciprestamos-pe-prod-web-peru-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248796e1"]])

export default __exports__